import React from "react";
import { navigate } from "@reach/router";
import gql from "graphql-tag";
import { constants } from "@services";
import { Box, Image, Flex, TextUppercase, TouchableOpacity } from "@atoms";
import { LinkBlockPromoLabel } from "../LinkBlockPromoLabel";
import { LinkBlockGives } from "../LinkBlockGives";
import { LinkBlockFragment } from "./__generated__/LinkBlockFragment";

// == Types ================================================================

export enum LinkType {
  BRAND = "BRAND",
  DEPARTMENT = "DEPARTMENT",
  EMPYR = "EMPYR",
  GIFTCARDOFFER = "GIFTCARDOFFER",
  PRODUCT = "PRODUCT",
}

interface IProps {
  link: LinkBlockFragment;
}

// == Constants ============================================================

const FRAGMENTS = {
  fields: gql`
    fragment LinkBlockFragment on Link {
      id
      type
      giftcardType
      name
      image
      logoImage
      giveSentence
      terms
      promoLabel
      promoDescription
      promoSecondaryLabel
      promoEndsAt
    }
  `,
};

// == Component ============================================================

const LinkBlock = ({ link }: IProps) => {
  const onClick = () => {
    navigate(`?${constants.linkParam}=${link.id}`);
  };

  const isGiftcard = link.type === "GIFTCARDOFFER"; // should be an enum
  // temp because clicking a link block on a carousel cauess it to perm faded
  // <TouchableOpacity containerProps={{ style: { width: "100%" } }} onTouch={onClick}></TouchableOpacity>
  return (
    <TouchableOpacity containerProps={{ style: { width: "100%" } }} onTouch={onClick}>
      <Flex flexDirection="column">
        <Box position="relative">
          {!!link.image && (
            <Image
              loading="lazy"
              alt="link-image"
              borderRadius={isGiftcard ? "giftcard" : 0}
              boxShadow="lightShadow"
              src={`${link.image}&w=250&h=187.5&fit=fill&bg=fff`}
            />
          )}
          {link.promoLabel && (
            <LinkBlockPromoLabel
              bottom="20px"
              label={link.promoLabel}
              left="0"
              position="absolute"
            />
          )}
        </Box>

        <TextUppercase ellipsis as="p" fontSize={[0]} pt={2} textAlign="center">
          {link.name}
        </TextUppercase>
        <LinkBlockGives
          giveSentence={link.giveSentence}
          promoEndsAt={link.promoEndsAt}
          secondaryLabel={link.promoSecondaryLabel}
        />
      </Flex>
    </TouchableOpacity>
  );
};

export default LinkBlock;

LinkBlock.fragments = FRAGMENTS;
// == Styles ===============================================================
